export const audio2 = "1eCiwDODGxZr4J1FQJr1jHgacRCWumDS5";
export const intro2 = "Glad you made it to lesson 2! We'll now learn a slightly simplified way of asking and answering questions. Note that to sound more natural we'd have to squeeze in a few extra words. For now, let's keep it simple!";

const nouns = ['woman', 'man', 'girl', 'boy'];
const adjs = ['happy', 'sad', 'hardworking', 'lazy'];

export const vocab2 = {
    yes: ['shì de', '是的'],
    no: ['bù', '不'],
    not: ['bù', '不'],
    happy: ['kāixīn', '开心'],
    sad: ['shāngxīn', '傷心'],
    hardworking: ['qínláo', '勤劳'],
    lazy: ['lǎnduò', '懒惰'],
    woman: ['nǚrén', '女人'],
    man: ['nánrén', '男人'],
    girl: ['nǚhái', '女孩'],
    boy: ['nánhái', '男孩'],
    is: ['', ''],
    the: ['', ''],
    '?': ['ma?', '吗？'],
    '!': ['!', '！'],
    ',': [',', '，'],
};

function litQuestion(noun: string, adj: string) {
    return [noun, adj, '?'];
}

function litAffirmative(noun: string, adj: string) {
    return ['yes', ',', noun, adj, '!'];
}

function litNegative(noun: string, adj: string) {
    return ['no', ',', noun, 'not', adj, '!'];
}

function transQuestion(noun: string, adj: string) {
    return ['is', 'the', noun, adj, '?'];
}

function transAffirmative(noun: string, adj: string) {
    return ['yes', ',', 'the', noun, 'is', adj, '!'];
}

function transNegative(noun: string, adj: string) {
    return ['no', ',', 'the', noun, 'is', 'not', adj, '!'];
}

export const lesson2 = [
    ...nouns.map(noun => (
        [
            {
                literal: litQuestion(noun, adjs[0]),
                translated: transQuestion(noun, adjs[0])
            },
            {
                literal: litAffirmative(noun, adjs[0]),
                translated: transAffirmative(noun, adjs[0])
            }

        ]
    )).flat(),
    ...nouns.map(noun => (
        [
            {
                literal: litQuestion(noun, adjs[1]),
                translated: transQuestion(noun, adjs[1])
            },
            {
                literal: litNegative(noun, adjs[1]),
                translated: transNegative(noun, adjs[1])
            }
        ]
    )).flat(),
    ...nouns.map(noun => (
        [
            {
                literal: litQuestion(noun, adjs[2]),
                translated: transQuestion(noun, adjs[2])
            },
            {
                literal: litAffirmative(noun, adjs[2]),
                translated: transAffirmative(noun, adjs[2])
            }
        ]
    )).flat(),
    ...nouns.map(noun => (
        [
            {
                literal: litQuestion(noun, adjs[3]),
                translated: transQuestion(noun, adjs[3])
            },
            {
                literal: litNegative(noun, adjs[3]),
                translated: transNegative(noun, adjs[3])
            }
        ]
    )).flat()
];